var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeleworkBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-42"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 263.74,
    y1: 24,
    x2: 263.74,
    y2: 293.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.34,437.24s-1-12.31,0-19.83,5.81-10.26,6.15-13.68-1.71-6.84.35-10.26a40.42,40.42,0,0,1,6.15-7.18s-2.73,5.13-.68,9.23,5.23,8.55,3.07,12-4.44,6.84-3.76,9.58,4.45,2.05,3.76,8.2-2.39,8.55-2.39,8.55l.34,3.42-11.62-.34",
    style: {
      fill: "#F8FF35",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.44,437.1s2.43-2.55-1.51-6.4c-2.55-2.49-5.05-6.19-5.17-10-.06-1.89.8-3.39.22-5.16-.63-1.93-2.6-3.15-3.14-5.3-1-4.15,1.75-8,2.09-9.35s0-1.41-1.85-5.07a15.35,15.35,0,0,1-1.76-6.82,6.9,6.9,0,0,0,5.09,4.86c4.3,1.12,6.76,3.88,6.46,9.11s-.65,6.54,3,7.49c5.72,1.5,5.15,5.43,4.51,10.23-.41,3-.57,3.79,1.21,6,1.45,1.77,3.7,1.47,1.94,4.53-1.94,3.38.85,6.23-2.56,7.11S406.44,437.1,406.44,437.1Z",
    style: {
      fill: "#F8FF35",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.86,437.67s-2.36-2.62,1.69-6.36c2.61-2.42,5.21-6.05,5.44-9.88.11-1.89-.7-3.42-.07-5.16.69-1.91,2.69-3.08,3.28-5.21,1.15-4.13-1.51-8.07-1.82-9.41s0-1.4,2-5a15.27,15.27,0,0,0,1.94-6.77,6.89,6.89,0,0,1-5.23,4.72c-4.33,1-6.86,3.69-6.71,8.92s.47,6.56-3.2,7.41c-5.76,1.33-5.31,5.28-4.8,10.1.32,3,.46,3.81-1.38,5.93-1.5,1.73-3.73,1.37-2.06,4.48,1.84,3.43-1,6.2,2.36,7.17S420.86,437.67,420.86,437.67Z",
    style: {
      fill: "#F8FF35",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.3,434.5V452a8.21,8.21,0,0,1-.05,1,10.25,10.25,0,0,1-.58,2.67A11,11,0,0,1,417.3,463h-6A11,11,0,0,1,401,455.67a10.25,10.25,0,0,1-.58-2.67,8.21,8.21,0,0,1-.05-1V434.5Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.33,
    y: 447,
    width: 27.97,
    height: 0.66,
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.25,451.39a10.25,10.25,0,0,1-.58,2.67H401a10.25,10.25,0,0,1-.58-2.67Z",
    style: {
      fill: "#263238",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-42"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 27.1,
    y1: 170.45,
    x2: 39.74,
    y2: 291.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.93,
    y1: 274.48,
    x2: 32.3,
    y2: 268.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.16,270.5a6.94,6.94,0,0,0-2.44-5.19c-1.57-1.41-9.83-4.88-10.62-2C20.25,266.5,28.71,272.72,34.16,270.5Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.16,
    y1: 270.5,
    x2: 26.29,
    y2: 265.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.33,
    y1: 287.84,
    x2: 33.83,
    y2: 283.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.69,285.21A6.91,6.91,0,0,0,33.26,280c-1.57-1.41-9.84-4.88-10.62-2C21.78,281.21,30.24,287.43,35.69,285.21Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.69,
    y1: 285.21,
    x2: 27.82,
    y2: 280.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.11,
    y1: 237.67,
    x2: 28.55,
    y2: 232.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.41,234.61A6.91,6.91,0,0,0,28,229.42c-1.57-1.41-9.84-4.88-10.62-2C16.5,230.61,25,236.83,30.41,234.61Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.41,
    y1: 234.61,
    x2: 22.54,
    y2: 229.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.66,
    y1: 253.31,
    x2: 30.09,
    y2: 247.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,249.32a6.94,6.94,0,0,0-2.44-5.19c-1.57-1.41-9.83-4.88-10.62-2C18,245.32,26.5,251.54,32,249.32Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.95,
    y1: 249.32,
    x2: 24.08,
    y2: 244.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.63,
    y1: 214.46,
    x2: 26.06,
    y2: 208.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.92,210.72a6.94,6.94,0,0,0-2.44-5.19c-1.57-1.41-9.83-4.88-10.62-2C14,206.72,22.47,212.94,27.92,210.72Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.92,
    y1: 210.72,
    x2: 20.05,
    y2: 205.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.95,
    y1: 188.91,
    x2: 23.55,
    y2: 184.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.41,186.72A6.91,6.91,0,0,0,23,181.53c-1.57-1.4-9.84-4.88-10.62-2C11.51,182.73,20,188.94,25.41,186.72Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.41,
    y1: 186.72,
    x2: 17.55,
    y2: 181.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.39,
    y1: 266.32,
    x2: 42.04,
    y2: 258.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.62,261a6.94,6.94,0,0,1,1.31-5.58c1.25-1.69,8.62-6.8,10-4.12C53.41,254.23,46.41,262.07,40.62,261Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.62,
    y1: 261.01,
    x2: 46.16,
    y2: 255.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.35,
    y1: 227.62,
    x2: 38,
    y2: 220.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.58,222.31a6.94,6.94,0,0,1,1.31-5.58c1.25-1.7,7-5.95,8.38-3.26C47.76,216.39,42.37,223.36,36.58,222.31Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.58,
    y1: 222.31,
    x2: 43.67,
    y2: 215.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.57,
    y1: 210.61,
    x2: 36.23,
    y2: 203.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.81,205.3a6.94,6.94,0,0,1,1.31-5.58c1.25-1.7,8.61-6.81,10-4.12C47.59,198.52,40.6,206.35,34.81,205.3Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.81,
    y1: 205.3,
    x2: 41.89,
    y2: 198.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.97,
    y1: 185.67,
    x2: 33.62,
    y2: 178.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2,180.36a6.92,6.92,0,0,1,1.32-5.58c1.24-1.69,8.61-6.8,10-4.12C45,173.59,38,181.42,32.2,180.36Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.2,
    y1: 180.36,
    x2: 39.29,
    y2: 173.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,169.73a6.94,6.94,0,0,1,1.31-5.58c1.25-1.7,8.62-6.81,10-4.12C39.77,163,32.77,170.78,27,169.73Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.98,
    y1: 169.73,
    x2: 34.07,
    y2: 162.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.39,170A6.91,6.91,0,0,1,22,168.13c-1.56-1.41-5.86-9.28-3.05-10.36C22,156.6,29.05,164.37,27.39,170Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.39,
    y1: 170.02,
    x2: 21.4,
    y2: 162.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.31,
    y1: 135.59,
    x2: 47.31,
    y2: 291.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.69,
    y1: 188.26,
    x2: 51.94,
    y2: 291.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.11,
    y1: 291.17,
    x2: 49,
    y2: 287.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,287.62A6.94,6.94,0,0,0,47.69,282c-1.25-1.7-8.62-6.8-10-4.12C36.21,280.85,43.21,288.67,49,287.62Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49,
    y1: 287.62,
    x2: 42.31,
    y2: 281.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.9,
    y1: 254.24,
    x2: 51.29,
    y2: 250.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.73,251.73a6.92,6.92,0,0,0-1.32-5.58c-1.24-1.7-8.62-6.81-10-4.12C39.94,245,46.94,252.78,52.73,251.73Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.73,
    y1: 251.73,
    x2: 46.04,
    y2: 245.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.44,
    y1: 271.74,
    x2: 49.78,
    y2: 264.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,266.43a6.94,6.94,0,0,0-1.31-5.58c-1.25-1.69-8.62-6.8-10-4.11C38.41,259.66,45.41,267.49,51.2,266.43Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.2,
    y1: 266.43,
    x2: 44.51,
    y2: 260.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.23,
    y1: 230.68,
    x2: 53.79,
    y2: 225.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.21,227.83a6.92,6.92,0,0,0-1.32-5.58c-1.25-1.69-8.62-6.8-10-4.11C42.42,221.06,49.42,228.89,55.21,227.83Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.21,
    y1: 227.83,
    x2: 48.52,
    y2: 221.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.57,
    y1: 208.22,
    x2: 56.28,
    y2: 201.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7,203.83a6.92,6.92,0,0,0-1.32-5.58c-1.25-1.69-8.62-6.8-10-4.11C44.91,197.06,51.91,204.89,57.7,203.83Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.7,
    y1: 203.83,
    x2: 51.01,
    y2: 197.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.02,
    y1: 284.2,
    x2: 59.14,
    y2: 277.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.28,279.67a7,7,0,0,1,2.43-5.19c1.57-1.41,9.84-4.89,10.62-2C71.19,275.67,62.73,281.89,57.28,279.67Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.28,
    y1: 279.67,
    x2: 65.61,
    y2: 274.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.04,
    y1: 245.49,
    x2: 63.16,
    y2: 239.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,241a6.91,6.91,0,0,1,2.43-5.19c1.57-1.4,9.83-4.89,10.62-2C75.2,237,66.75,243.18,61.3,241Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.3,
    y1: 240.96,
    x2: 69.63,
    y2: 235.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.81,
    y1: 228.48,
    x2: 64.92,
    y2: 222.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.06,224a6.94,6.94,0,0,1,2.44-5.19c1.57-1.4,9.83-4.89,10.61-2C77,220,68.51,226.17,63.06,224Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.06,
    y1: 223.95,
    x2: 71.39,
    y2: 218.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.32,
    y1: 202.27,
    x2: 67.51,
    y2: 197.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,199a6.92,6.92,0,0,1,2.43-5.19c1.57-1.4,9.84-4.88,10.62-2C79.56,195,71.1,201.24,65.65,199Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.65,
    y1: 199.01,
    x2: 73.98,
    y2: 193.85,
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73,187.53a6.91,6.91,0,0,1,2.43-5.19c1.57-1.4,9.83-4.88,10.62-2C76.64,183.53,68.18,189.75,62.73,187.53Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.73,
    y1: 187.53,
    x2: 71.06,
    y2: 182.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.07,187.9a6.92,6.92,0,0,1-4.91-3c-1.23-1.71-3.82-10.29-.85-10.77C60.55,173.65,65.85,182.72,63.07,187.9Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.07,
    y1: 187.9,
    x2: 58.8,
    y2: 179.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.09,
    y1: 274.25,
    x2: 42.03,
    y2: 267.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,269.61a6.93,6.93,0,0,0-1.89-5.42c-1.41-1.55-9.27-5.87-10.35-3.06C30.26,264.19,38,271.26,43.68,269.61Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.68,
    y1: 269.61,
    x2: 36.36,
    y2: 263.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.27,
    y1: 241.63,
    x2: 42.03,
    y2: 236.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,238.87a6.91,6.91,0,0,0-1.89-5.41c-1.41-1.56-9.27-5.88-10.35-3.06C30.26,233.46,38,240.52,43.68,238.87Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.68,
    y1: 238.87,
    x2: 36.36,
    y2: 233.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.44,
    y1: 207.73,
    x2: 42.03,
    y2: 200.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,202.79a6.93,6.93,0,0,0-1.89-5.42c-1.41-1.55-9.27-5.87-10.35-3.06C30.26,197.37,38,204.44,43.68,202.79Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.68,
    y1: 202.79,
    x2: 36.36,
    y2: 197.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.09,
    y1: 181.21,
    x2: 42.03,
    y2: 176.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,178.77a6.93,6.93,0,0,0-1.89-5.42c-1.41-1.56-9.27-5.87-10.35-3.06C30.26,173.35,38,180.41,43.68,178.77Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.68,
    y1: 178.77,
    x2: 36.36,
    y2: 173.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.38,
    y1: 157.18,
    x2: 42.13,
    y2: 153.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,154.64a6.91,6.91,0,0,0-1.89-5.41c-1.41-1.56-9.27-5.88-10.35-3.07C30.26,149.23,38,156.29,43.68,154.64Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.68,
    y1: 154.64,
    x2: 36.36,
    y2: 148.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.37,
    y1: 282.42,
    x2: 52.74,
    y2: 276.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09,279A6.93,6.93,0,0,1,53,273.58c1.42-1.56,9.28-5.88,10.36-3.06C64.51,273.58,56.74,280.64,51.09,279Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.09,
    y1: 278.99,
    x2: 58.84,
    y2: 272.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.32,
    y1: 235.06,
    x2: 52.74,
    y2: 227.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09,230.11A6.93,6.93,0,0,1,53,224.7c1.42-1.56,9.28-5.88,10.36-3.06C64.51,224.7,56.74,231.76,51.09,230.11Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.09,
    y1: 230.11,
    x2: 58.84,
    y2: 224.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.32,
    y1: 210.93,
    x2: 52.74,
    y2: 203.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09,206A6.93,6.93,0,0,1,53,200.57c1.42-1.56,9.28-5.87,10.36-3.06C64.51,200.57,56.74,207.63,51.09,206Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.09,
    y1: 205.98,
    x2: 58.84,
    y2: 199.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.32,
    y1: 179.04,
    x2: 52.74,
    y2: 171.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09,174.1A7,7,0,0,1,53,168.68c1.42-1.56,9.28-5.87,10.36-3.06C64.51,168.68,56.74,175.74,51.09,174.1Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.09,
    y1: 174.1,
    x2: 58.84,
    y2: 168.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.56,
    y1: 151.52,
    x2: 52.87,
    y2: 147.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09,149A6.93,6.93,0,0,1,53,143.61c1.42-1.56,9.28-5.87,10.36-3.06C64.51,143.61,56.74,150.67,51.09,149Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.09,
    y1: 149.02,
    x2: 58.84,
    y2: 143.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,137.91a7,7,0,0,1,1.88-5.42c1.42-1.56,9.28-5.87,10.36-3.06C60.42,132.49,52.65,139.55,47,137.91Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 137.91,
    x2: 54.75,
    y2: 131.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.38,138.24a6.94,6.94,0,0,1-5.19-2.44c-1.4-1.57-4.87-9.84-2-10.62C43.4,124.33,49.61,132.79,47.38,138.24Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.38,
    y1: 138.24,
    x2: 42.22,
    y2: 129.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.81,187.92s-23.44,11.2-28,18c-2,2.95-15.34,56.26-15.34,56.26l-8.84,7.37,13.55,24h80.47s5.89-83,4.71-87.1S429.2,190.28,426,188.8,414.47,186.44,411.81,187.92Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "401.16 248.31 416.12 260.66 404.28 253.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 395.17,
    y1: 243.36,
    x2: 398.79,
    y2: 246.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.05,280s-2.78.42-3.89,2.22-3.2,6.95-2.23,7.37,1.67-1.11,2.37-2.22,1.66-2.78,1.66-2.78l2.23-.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.94,277.32s-3.2-.28-4,1.11-2.5,10.56-2.36,11.68,1.53,1.66,2.64-.28,3.47-10.56,3.47-10.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.47,277.18s-4.72-2.22-6.67-1.8-4.72,14.59-4.31,15.28a2.08,2.08,0,0,0,3.06-.28c.69-1.11,4.72-7.92,5.84-9.58A38.82,38.82,0,0,0,326.47,277.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,284.45s-1.81-12.32-5.11-17.12-5.74-.67-10.73,1.93c-3,1.58-21.12,9.18-22,9.48s-8.71-4.21-10.21-3-7.21,8.41-8.41,12.31,1.8,4.21,3,3,4.81-6.91,6.31-8.11,5.11,2.7,5.11,2.7-5.41,2.7-7.21,3.91.9,1.8,3.9,1.8a23.17,23.17,0,0,0,8.71-2.1l3-1.51S365.05,287.75,375,284.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,110.11s-23.28,10-25.35,16.8,2.36,7.66,2.95,11.2-15.62,20-9.13,30.36,41.85,13,56.58,10.31,24.17-13,23.29-24.76-8-17.39-16.8-30.65S419.77,108.05,413.58,110.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.78,152.55s-3.83.3-3.83,3.24,3.83,9.14,5.6,8.84S396.78,152.55,396.78,152.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.16,126.91s-13.56,9.43-13.26,14.74-.59,18.56,3.83,27.41a144.2,144.2,0,0,0,10.61,17.38s-2.65,23-2.36,28.89,5,2.95,10.32-3.54,10.61-20.92,10.61-20.92L425.67,187l.59-4.71s7.07-6.19,9.13-11.5c1.12-2.86.89-9.13.89-9.13a9.1,9.1,0,0,0,5-5.31l1.18-3.83a76.09,76.09,0,0,1-7.67-4.42,102.71,102.71,0,0,1-8.84-8S413.88,134,409.16,126.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.57,148.42s-1.47,15,.3,18.28,6.48,0,6.48,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,172.89s7.67,1.47,11.79-3.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.18,
    cy: 149.75,
    rx: 1.77,
    ry: 2.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.68,
    cy: 149.75,
    rx: 1.77,
    ry: 2.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.94,141.65s4.42-1.77,7.07.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.92,141.94s-4.42-2.06-6.19,2.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "383.91 238.26 387.58 257.71 380.07 285.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.48,
    y1: 230.67,
    x2: 383.09,
    y2: 233.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.31,200.89s9.24,4.32,8.73,7.31,2.21,68.92-1,73.46-12.15,3-12.15,3-3.8-11.83-7.68-15.41-5.3-2.36-5.3-2.36l2.65-40.09",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.29,280.82a19.23,19.23,0,0,1-4.67,4.11c-2.74,1.65-6.31,2.47-3.84,3.57s6.31-.55,8.51-1.92S365.29,280.82,365.29,280.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,275.34c6-3.66,11.38-9.75,18.85-10s14.35,5,17.65,11.32c1.08,2.07,1.83,4.5,1.15,6.73-1.27,4.2-6.52,5.42-10.87,5.93l-24,2.85c-14.38,1.7-29.52,3.3-42.86-2.34a6.2,6.2,0,0,1-1.62,3.4c-1,.83-2.77.79-3.27-.38a3.16,3.16,0,0,1-3.92.32c-.25-.15-1.53.51-2.86.28-.47-.09-2.11-.81-2.58-.92a2.38,2.38,0,0,1-1.6-.9,2.43,2.43,0,0,1-.24-1.28,27.65,27.65,0,0,1,.8-8.42c3.38-10.84,15.48-4.9,21.91-.64,2.19,1.45,4.5,2.94,7.11,3.19a16.23,16.23,0,0,0,5.76-.87c6.91-1.93,14.2-4.36,20.52-8.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.21,
    y1: 289.8,
    x2: 381.25,
    y2: 285.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.44,292.34s.55-11.25,2.47-13.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.6,292.61s-.83-9.87,1.09-14.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44,292.57s-.78-7.55.59-12.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2,293.72l-7.5-70.31a3.72,3.72,0,0,1,3.71-4.12H79.88a3.72,3.72,0,0,1,3.64,2.92l15.84,71.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.47,174.48S63.9,190.74,63.06,197.19s-3.36,96.42-3.36,96.42h80.19s-7.85-35.29-8.69-39.5-2-11.49-2-11.49l26.42,12,3.92-26.35s-13.8-19.87-22.49-30.81-19.91-19.35-25-20.47S94.47,174.48,94.47,174.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "129.24 242.62 130.75 229.76 134.99 214.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.75,
    y1: 229.76,
    x2: 131.6,
    y2: 216.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.38,248.43c.72.29,1.4.58,2,.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.94,240.52s14.19,3.26,24,6.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.21,208.25s1.42,22.36,2,23.78,3.68.28,3.68.28l-2-13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.15,
    y1: 221.47,
    x2: 88.28,
    y2: 218.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.52,
    y1: 233.73,
    x2: 84.01,
    y2: 224.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66,168s-9,2-10.65,3.64-4.49,12.06-4.49,12.06l5,26.36s14.3-12.62,16.26-13.18,18.79,9.25,18.79,9.25-.56-13.18-4.77-21.59-7.85-11.77-11.77-14.3A15.51,15.51,0,0,0,103.66,168Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66,149.8s-2,14.58-2.52,19.35-3.36,2.52-1.68,8.41,10.93,30,12.9,28,8.13-25.79,9.53-27.48,3.93-5,3.93-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.48,151.14c-.38,2.86-1.29,9.68-1.9,14.45L123,173.16l-1.72-4.82-15.73-16.53Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.91,189.34s-10.65,5.89-10.93,9S40.07,270.38,42,275.7s11.22,6.17,11.22,6.17,8.69-14.3,13.46-16.82A53.85,53.85,0,0,1,73.16,262L83.25,214",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.17,278.23a19.71,19.71,0,0,0,4.77,4.2c2.8,1.69,6.45,2.53,3.93,3.65s-6.45-.56-8.7-2S140.17,278.23,140.17,278.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48,267s-.16-.21-.46-.56a22.05,22.05,0,0,0-6-5.05c-3.37-1.68-13.46-2-22.16,8.14s-4.2,15.14,2.81,16.82,33.37,3.08,39.81,4.21,18.51,2,23,0a87.77,87.77,0,0,1,9.25-3.37s1.4,4.49,3.37,4.49S129.8,290,129.8,290s1.12,1.13,2,1.13a4.31,4.31,0,0,0,2-.84,3.54,3.54,0,0,0,3.09.56c1.68-.56,1.68-1.41,1.68-1.41s2,1.69,2.81,0-.57-7.29-1.13-11.21-3.36-3.93-3.36-3.93l-.86-.61a3.71,3.71,0,0,0-3-.58l-1.44.35s-2.8-.56-4.21,0-13.17,7.57-14.86,8.41-6.17,0-11.21-2S81,271.22,78.48,267Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.75,
    y1: 287.2,
    x2: 123.86,
    y2: 283.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.73,277.39C63.9,269,78.48,267,78.48,267s-.16-.21-.46-.56a22.05,22.05,0,0,0-6-5.05c-3.37-1.68-13.46-2-22.16,8.14s-4.2,15.14,2.81,16.82c.79.19,1.85.38,3.09.56C55,284.42,55,281.12,57.73,277.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8,290s-.56-11.49-2.53-14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,290.29s.85-10.1-1.12-14.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.49,289.44a50.38,50.38,0,0,0-1.12-12.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55,228.26s-3-3.94-4.92-2-4.53,18.7-4.53,23.82-.79,4.92,5.31,6.1,8.27,1.58,10.64.4-1-8.67-2.76-14.77S159.55,228.26,159.55,228.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,143.15a4.92,4.92,0,0,1,2.48.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,160.21a17,17,0,0,0,2-2.15c2.23-2.79,4.07-10.73,7.82-13.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,158.87s3-1.55,3.84-7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.47,186.32,162.3,199.7s18.12,37.81,18.32,44.9-2,11.22-9.85,12-9.84-1-11.81-8.86-3.35-47.26-3.35-47.26-3.74-5.12-4.73-6.89a14.16,14.16,0,0,1-1.37-5.12c0-.59-1.38-17.13-1.38-17.13l14.17-.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.37,184.64l-7.26,1.07a1.68,1.68,0,0,1-2-1.33l-.36-1.82a1.68,1.68,0,0,1,1.33-2l7.26-1.06a1.67,1.67,0,0,1,2,1.32l.36,1.82A1.69,1.69,0,0,1,163.37,184.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3,188.46l-5.27.78a1.22,1.22,0,0,1-1.44-1l-.26-1.32a1.22,1.22,0,0,1,1-1.43l5.27-.78a1.24,1.24,0,0,1,1.44,1l.26,1.32A1.22,1.22,0,0,1,164.3,188.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,173.71l-7.68,1.13a1.78,1.78,0,0,1-2.09-1.4l-.37-1.93a1.77,1.77,0,0,1,1.4-2.08l7.68-1.13a1.78,1.78,0,0,1,2.08,1.4l.38,1.93A1.77,1.77,0,0,1,163.49,173.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27,179.42l-7.68,1.13a1.77,1.77,0,0,1-2.08-1.4l-.38-1.93a1.77,1.77,0,0,1,1.4-2.08l7.68-1.13a1.79,1.79,0,0,1,2.09,1.4l.37,1.93A1.76,1.76,0,0,1,164.27,179.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,142.08s-2.12-21.28-4.68-28.52,6.81-15.32,28.94-14.89,30.22,10.21,30.64,14.89-5.11,8.09-5.11,8.09l-2.12,6-19.58-4.68s0,5.1-1.7,7.23-11.49,5.53-11.49,5.53-2.13,7.66-5.53,11.49-8.52,3.41-8.94.86A43.59,43.59,0,0,1,101.27,142.08Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.38,145.91s1.28-8.51-5.53-8.51-5.11,8.51-3,12.76,4.68,5.11,4.68,5.11,13.19,17.45,17.87,20,7.24,4.26,10.64,2.55,13.62-14.46,15.32-21.27a52.2,52.2,0,0,0,1.71-11.49s3.83-8.09,3.83-11.92-.86-11.49-.86-11.49-18.72-6.81-24.25-5.53-8.09.85-5.54,3,3.83,8.51,2.13,9.36-11.91.85-11.91,4.68,1.27,6-.43,8.09A44.63,44.63,0,0,1,106.38,145.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,159.56s5.89.84,7-.56.85-12.06.85-12.06l4.2-5.89s2.53-1.68,3.65,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.24,
    y1: 168.53,
    x2: 136.17,
    y2: 167.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,144.92c-.4,1.5-1.44,2.54-2.33,2.3s-1.27-1.64-.87-3.15,1.44-2.54,2.32-2.31S131.2,143.41,130.8,144.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.74,147.37c-.4,1.51-1.44,2.54-2.32,2.3s-1.28-1.64-.88-3.15,1.44-2.54,2.32-2.31S147.14,145.86,146.74,147.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,137.41s4.21-2.81,10.38.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62,164l4.53,29.44,15.57-1.13.85-29.73S150.06,160.34,135.62,164Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-3--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.42,405.63l11.95,50.6a2.41,2.41,0,0,1-2.35,3H341.94V463H361a4.48,4.48,0,0,0,4.34-5.61l-15-57.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.89,
    y: 352.47,
    width: 6.75,
    height: 95.34,
    transform: "matrix(0.98, 0.17, -0.17, 0.98, 74.84, -54.44)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 460.37,
    width: 60.99,
    height: 2.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.71,
    y: 290.35,
    width: 119.45,
    height: 3.42,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.22,
    y: 290.35,
    width: 41.93,
    height: 3.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.64,290.35H285.08l-7.54-51.58a3.75,3.75,0,0,1,3.79-4.45H350a5.33,5.33,0,0,1,5.09,4.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.15,290.35H283.59l-7.54-51.58a3.75,3.75,0,0,1,3.8-4.45h68.66a5.34,5.34,0,0,1,5.1,4.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.96,
    y: 290.28,
    width: 122.08,
    height: 3.49,
    transform: "translate(361.99 584.05) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.96,
    y: 290.28,
    width: 42.85,
    height: 3.49,
    transform: "translate(282.77 584.05) rotate(180)",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.37,290.28h79.26l7.71-52.72a3.84,3.84,0,0,0-3.88-4.55H174.29a5.45,5.45,0,0,0-5.21,4.55Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.89,290.28h79.26l7.71-52.72A3.84,3.84,0,0,0,246,233H175.81a5.45,5.45,0,0,0-5.21,4.55Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.85,260a6,6,0,0,1,5.69-5,4.19,4.19,0,0,1,4.25,5,6,6,0,0,1-5.7,5A4.2,4.2,0,0,1,204.85,260Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-3--inject-42"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 463.01,
    x2: 491.72,
    y2: 463.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-2--inject-42"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 481.73,
    y1: 293.77,
    x2: 269.61,
    y2: 293.77,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-1--inject-42"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 256.98,
    y1: 293.77,
    x2: 22.64,
    y2: 293.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.91,306s-1.79-17.2-10.78-22.59-4.36,9.24-4.36,10-13.35-14.12-24.65-5.91-.77,25.42-.77,25.42-13.6-4.62-13.35.26,12.84,9,12.84,9-22.85,2.31-14.63,12.58,30.55,2.82,30.55,2.82-6.17,6.68-1.8,7.45,21-12.32,22.59-15.66S195.82,316,189.91,306Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.76,337.51s8.35-.44,12.75-7.47,2.63-11.87-4-14.5-15.82-1.32-15.82-1.32S219.66,296.64,199.88,301s-22.42,19.78-21.1,27.69l5.28,31.65s16.26,2.64,20.66-1.76,12.74-20.22,21.53-22.41S240.76,337.51,240.76,337.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.69,352.67c-.54,3.95-3.37,9.5-6.09,9.13s-4.5-3.86-4-7.81,3.39-4.5,6.11-4.13S244.22,348.73,243.69,352.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.8,348.06s3.52,1.32,8.8-2.63,5.27-13.63,16.7-15.83,18.9,3.08,19.34,6.16-1.32,9.23-1.32,15.38,1.32,9.23,2.64,10.55,3.07.44.44,3.08a49.73,49.73,0,0,1-7.92,5.71s-7.47,14.07-10.54,16.7-10.55,1.32-13.19,0-8.35-4.39-8.35-4.39l-3.52,12.31L178.78,378l5.28-17.58S194.61,357.73,196.8,348.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.4 382.79 197.74 376.36 200.79 389.79 203.4 382.79",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.88,353.91c-.15,1.69-1,3-1.94,2.91s-1.53-1.52-1.38-3.22,1-3,1.94-2.91S237,352.21,236.88,353.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.48,
    y1: 349.86,
    x2: 198.38,
    y2: 347.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.43,
    y1: 354.01,
    x2: 240.87,
    y2: 354.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.76,343.23a5.86,5.86,0,0,1,6.67.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.76,375.58s-3.34,0-5.65-3.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,406.51,207,463.26H120.27s13.55-43.2,17.79-52.23,9.6-13,9.6-13,11-9.88,26-7.91S203,406.51,203,406.51Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.44,351.58s-1.76-8.79-7.91-7.47-3.08,14.94.88,18.9,6.59-.44,6.59-.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,410.18s3.39-5.93.57-10.73S194,385.05,182.39,376s-26.83-20.61-29.08-14.4-4,18.35-4,18.35-9.88,1.69-11,4.8-2.26,18.64-.56,20.61,2.82-.28,6.49-.28,26-7.34,34.45-6.78,9.88,3.11,16.37,6.5S204.69,410.18,204.69,410.18Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.89,399.94a27.74,27.74,0,0,1,4.39,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.09,385.69c6.46-1.34,14.3-2.05,19.8.49a136.47,136.47,0,0,1,20,11.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.55,389a78.37,78.37,0,0,1,9.86-2.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,380s7.06-2.82,16.66.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,408.77c2.26-4.8,9.6-15.53,20.9-9.88s14.11,19.2,19.2,35.86,9.88,28.51,9.88,28.51H171.66l-10.45-42.07",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.34,463.18l4.67-4s5.54,1.33,14.56-1.45,12-5.46,12-5.46a67.14,67.14,0,0,1,8.15,4.56c4.14,2.75,7.14,3.81,11.14,2.72s-1.09-2.19-5.52-5.31-9.77-7.43-9.77-7.43,8.37,4,11.29,5.1,5.82,2.91,8.37,1.82,1.45-2.19-5.1-5.46c-6-3-12.74-8.74-16-8.74s-18.2,6.19-18.2,6.19l-29.21,17.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.55,456.13a14.58,14.58,0,0,0,6.84.5c3.27-.73,7.64-1.46,7.64-1.46s8.73.37,11.65,0,2.18-2.18-2.55-4-22.56-2.91-22.93-1.82A59.93,59.93,0,0,0,264.55,456.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,446.41s6.92,2.59,8.22,3.45,3.89,1.52,2.8,3-4.53.22-6.91-.22a24.86,24.86,0,0,1-5.4-1.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.2,442.52s12.31.65,15.12,1.51,5,6.7,5.41,8.43,1.94,3.89.64,4.1-6.05-5.18-8-6.26-9.73-4.76-12.54-5.84S271.68,442.3,273.2,442.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.07,461.05s28.23-20,31.25-20,16.56,6,19.57,7.53,6.78,9.79,6.78,9.79-.76,1.88-3.39.38-5.65-6.4-5.65-6.4l-15-.58s-3.79,3.57-6.05,4.32a52.23,52.23,0,0,1-7.56,1.3l-4.86,4.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.5 451.38 256.99 463.26 228.9 463.26 250.5 451.38",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9,349.29s-8.45-3.1-9.58-1.12-2.25,9.29,2.26,12.39,6.85-6.55,6.85-6.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-42"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 118,
    r: 37,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 118,
    r: 32.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "255.17 127.26 264 118 286.99 134.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleworkBro);
export default __webpack_public_path__ + "static/media/Telework-bro.811d23c285654bdf913411bf33bb2a68.svg";
export { ForwardRef as ReactComponent };